import { IonCol, IonItem } from "@ionic/react";
import { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import { makeGETRequest } from "../../request/rawRequest";
import { RealMarkedType } from "../../types/real";
import { getCurrentTechnoOrDisconnect } from "../../variables/jobDictionnary";
import BasicPage from "../BasicPage/BasicPage";
import "../IonColor/color.css";
import "../generalCSS/stylesheet.css";
import "./realMarked.css";

interface ContainerProps {}

const RealMarked: React.FC<ContainerProps> = () => {
  const [markedReal, setMarkedReal] = useState<RealMarkedType[]>([]);
  const fetchRealisation = async () => {
    await makeGETRequest("/me").then(async (response: any) => {
      await makeGETRequest(
        "/realidation/category?category=" +
          getCurrentTechnoOrDisconnect() +
          "&email=" +
          response.email
      ).then((response) => {
        setMarkedReal((response as []).reverse());
      });
    });
  };

  useEffect(() => {
    fetchRealisation();
  }, []);

  return (
    <BasicPage pathReturn title="Mes travaux corrigés">
      {markedReal?.map((m, i) => {
        return (
          <IonCol size-sm="12" key={i} className="ion-padding-top">
            <Carousel
              autoPlay={false}
              infiniteLoop={true}
              showArrows={true}
              showStatus={false}
              showThumbs={false}
              showIndicators={true}
              emulateTouch={true}
              swipeable={true}
              className="input-carousel"
            >
              {m?.link.map((img, i) => {
                return <img src={img} key={i} className="input-img"></img>;
              })}
            </Carousel>
            <IonItem color="light">
              <div
                className="btn"
                onClick={() => {
                  window.open(m?.correction[0], "_blank", "noreferrer");
                }}
              >
                Voir ma note pour {m.exercice}
              </div>
            </IonItem>
          </IonCol>
        );
      })}
    </BasicPage>
  );
};

export default RealMarked;
